/**
 * Página MOBILE "Mais" (Task #31 Fase 3) — lista as views que são ferramentas de
 * DESKTOP (conferência/Mesa/histórico denso/entrada de dados) com aviso claro
 * "melhor no desktop", em vez de espremer tabelas densas no celular. READ-ONLY.
 */
import { DesktopOnlyNotice, MobileHeader } from "./mobileUi";

const DESKTOP_ONLY = [
  { titulo: "Liquidações — detalhe / conferência", descricao: "A tabela de detalhe é ferramenta de conferência de fechamento, com muitas colunas." },
  { titulo: "Mesa de Operações", descricao: "Curva de mercado, trades e posição detalhada." },
  { titulo: "Histórico detalhado", descricao: "Séries longas e tabelas comparativas (Realizado × DECOMP)." },
  { titulo: "Entrada de dados (DECOMP, etc.)", descricao: "Cadastros e formulários ficam no desktop — o mobile é só leitura." },
];

export function MobileMais({ onLogout }: { onLogout: () => void }) {
  return (
    <div className="min-h-screen bg-indra-azul" data-testid="mobile-mais">
      <MobileHeader subtitle="Mais" onLogout={onLogout} />
      <main className="px-4 py-4 flex flex-col gap-4 max-w-md mx-auto">
        <p className="text-white/50 text-xs">
          O mobile cobre as leituras-chave (Resumo · Fluxo · PLD). As views abaixo
          são densas / de entrada de dados — ficam no desktop.
        </p>
        {DESKTOP_ONLY.map((v) => (
          <DesktopOnlyNotice key={v.titulo} titulo={v.titulo} descricao={v.descricao} />
        ))}
      </main>
    </div>
  );
}
